export default {
  meta: {
    title: '商圈洞察PDF'
  }
};
